import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  @Input() showSearchInput = true;
  @Input() inputClass = '';
  @Input() searchPlaceholder = '';
  @Input() dropDownChoices: [] | {};
  @Output() selectChange = new EventEmitter<string>();
  @Output() searchChange = new EventEmitter<string>();

  search: FormControl = new FormControl();

  constructor() {}

  ngOnInit(): void {
    this.search.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value: string) => {
        this.searchChange.emit(value);
      });
  }

  onSelect(event: { target: HTMLSelectElement }): void {
    this.selectChange.emit(event.target.value);
  }
}
